// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileZipFilledSvg from "@fishx/icons-svg/es/asn/FileZipFilled";
import FishxIcon from '../components/FishxIcon';

var FileZipFilled = function FileZipFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileZipFilledSvg
  }));
};

FileZipFilled.displayName = 'FileZipFilled';
export default React.forwardRef(FileZipFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileZipFilled.js
// module id = 2768
// module chunks = 0